var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.087 21.087v-.913q-2.854-.32-4.897-2.363t-2.364-4.898h-.913a.88.88 0 0 1-.65-.262A.88.88 0 0 1 2 12q0-.389.263-.65a.88.88 0 0 1 .65-.263h.913q.32-2.854 2.363-4.897t4.898-2.364v-.913q0-.388.262-.65A.88.88 0 0 1 12 2q.389 0 .65.263a.88.88 0 0 1 .263.65v.913q2.854.32 4.898 2.363t2.363 4.898h.913q.388 0 .65.262A.88.88 0 0 1 22 12a.88.88 0 0 1-.263.65.88.88 0 0 1-.65.263h-.913q-.32 2.854-2.363 4.898t-4.898 2.363v.913a.88.88 0 0 1-.262.65A.88.88 0 0 1 12 22a.88.88 0 0 1-.65-.263.88.88 0 0 1-.263-.65M12 18.393q2.65 0 4.52-1.873 1.873-1.87 1.873-4.52T16.52 7.48Q14.65 5.606 12 5.606T7.48 7.48Q5.606 9.352 5.606 12q0 2.65 1.872 4.52Q9.352 18.394 12 18.394m0-2.74q-1.507 0-2.58-1.073T8.347 12 9.42 9.42 12 8.347t2.58 1.073T15.653 12t-1.073 2.58T12 15.653m0-1.827a1.76 1.76 0 0 0 1.29-.536 1.76 1.76 0 0 0 .537-1.29 1.76 1.76 0 0 0-.537-1.29 1.76 1.76 0 0 0-1.29-.537 1.76 1.76 0 0 0-1.29.537 1.76 1.76 0 0 0-.537 1.29q0 .753.537 1.29a1.76 1.76 0 0 0 1.29.537"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyLocation);
export default __webpack_public_path__ + "static/media/my_location.8c5168018d79df9d832359bb96b85a8d.svg";
export { ForwardRef as ReactComponent };